import React, {Component} from 'react';
import media from '../MediaQueries.js';
import styled from 'styled-components';

import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem,
        NavLink, Container, Row, Col, Jumbotron, Button } from 'reactstrap';
import { Link } from 'react-router-dom'
import recipesBGMobile from '../media/mobilerecipesectionbackground.jpg'
import recipesBGDesktop from '../media/checkoutrecipepagebackground.jpg'
import recipesBGAbove1200 from '../media/croppedcheckoutrecipe.jpg'



const RecipesSection = (props) => {

	return (
	  <FluidContainer fluid>
	    <InternalContainer>
	    	<ContentAreaDiv>
				<h3>Maple goes with more than just pancakes. Check out our recipe page!</h3>
			  	<Link to="/Recipes">
				  	<CheckOutRecipesButton>
						<p>Recipes</p>
					</CheckOutRecipesButton>
			  	</Link>
				
			{/*
			  <Row>
				<LeavesImgCol xs="4">
					<LeavesImg src={require("../media/leavespng2.png")}></LeavesImg>
				</LeavesImgCol>
			  	<Col xs="8"></Col>
			  </Row>
			*/}

	    	</ContentAreaDiv>
	      
		  
	    </InternalContainer>
	  </FluidContainer>
	); 
};



const FluidContainer = styled(Container)`
	padding: 20px 0 20px 0!important;
	background-image: url(${recipesBGMobile}); 
    background-size: 100%; /* size the background image at 100% like any responsive img tag */
    background-position: top center;
    background-repeat:repeat;

	${media.sm` background-image: url(${recipesBGDesktop}); background-repeat:repeat;  `}
	${media.xl` background-image: url(${recipesBGAbove1200}); background-repeat:no-repeat;  `}
`;

const ContentAreaDiv = styled.div`
	
`;

const InternalContainer = styled(Container)`
	text-align: center;

	h3 { 
		margin: 0 auto;
		margin-top: 18%;
		max-width: 300px;

		${media.sm` margin: 12% 0 0 30%; `}
		${media.sm650` margin: 15% 0 0 33%; `}
		${media.md` max-width: 360px; margin: 14% 0 0 33%; `}
		${media.md900` max-width: 360px; margin: 16% 0 0 33%; `}
		${media.lg` max-width: 540px; margin: 13% 0 0 30%; `}
		${media.lg1100` max-width: 540px; margin: 15% 0 0 32%; `}
		${media.xl` max-width: 610px; margin: 1% 0 0 32%; `}
		${media.xl1450` margin: 1% 0 0 34%; `}
		${media.xxl` margin: 1% 0 0 34%; `}
		${media.xxl1800` margin: 1% 0 0 37%; `}
	}
`;

const CheckOutRecipesButton = styled(Button)`
  margin: 18% 0 10% 0;
  ${media.xs370` margin: 23% 0 10% 0; `}
  ${media.xs400` margin: 26% 0 10% 0; `}
  ${media.xs450` margin: 28% 0 10% 0; `}
  ${media.xs500` margin: 31% 0 10% 0; `}
  ${media.sm` margin: 15% 0 8% 21%; `}
  ${media.sm600` margin: 17% 0 9% 21%; `}
  ${media.sm650` margin: 20% 0 7% 21%; `}
  ${media.sm700` margin: 24% 0 7% 21%; `}
  ${media.sm740` margin: 26% 0 10% 21%; `}
  ${media.md` margin: 17% 0 8% 17%; `}
  ${media.md800` margin: 20% 0 8% 17%; `}
  ${media.md850` margin: 24% 0 8% 17%; `}
  ${media.md900` margin: 25% 0 8% 17%; `}
  ${media.md950` margin: 28% 0 8% 17%; `}
  ${media.lg` margin: 23% 0 8% 17%; width: 200px;`}
  ${media.lg1020` margin: 25% 0 8% 17%;`}
  ${media.lg1060` margin: 27% 0 8% 17%;`}
  ${media.lg1100` margin: 28% 0 8% 19%;`}
  ${media.lg1150` margin: 31% 0 8% 19%;`}
  ${media.xl` margin: 25% 0 2% 17%; width: 290px;`}
  ${media.xl1250` margin: 26% 0 3% 19%;`}
  ${media.xl1300` margin: 27% 0 4.5% 19%;`}
  ${media.xl1350` margin: 29% 0 3.5% 19%;`}
  ${media.xl1400` margin: 30% 0 4% 19%;`}
  ${media.xl1450` margin: 31% 0 4.5% 21%;`}
  ${media.xl1500` margin: 32% 0 5.5% 21%;`}
  ${media.xl1550` margin: 34% 0 5% 21%;`}

  ${media.xxl` margin: 36% 0 5% 23%;`}
  ${media.xxl1650` margin: 37% 0 5% 23%;`}
  ${media.xxl1700` margin: 39% 0 5% 23%;`}
  ${media.xxl1750` margin: 40% 0 6% 23%;`}
  ${media.xxl1800` margin: 40% 0 7.5% 25%;`}
  ${media.xxl1850` margin: 42% 0 7.5% 25%;`}
  ${media.xxl1900` margin: 43% 0 7% 26.5%;`}
  ${media.xxl1920` margin: 44% 0 7% 26.5%;`}


  cursor: pointer;
  display: block;
  border: 0px!important;
  color: white!important;
  font-weight: bold!important;
  background-color: #800000!important;
  width: 150px;
  height: 40px;
  line-height: 20px!important;
  transition: all 0.5s;


	
  p {
    cursor: pointer;
    display: inline;
    position: relative;
    transition: 0.5s;
  }

  p:after {
    content: '\00bb';
    position: absolute;
    opacity: 0;
    right: -20px;
    transition: 0s;
  }

  :hover p { padding-right: 25px; }
  :hover p:after { opacity: 1; right: 0; }
  :active p:after { opacity: 0; }
  :active { box-shadow: 0 5px #666; transform: translateY(6px); }
`;


/*
const ListViewContainer = styled(({ listSelected, ...rest }) => <Container {...rest} />)`
  display: ${a => a.listSelected ? "block" : "none"};
  ${media.sm` background-image: url(${smHeroImage}); height: 362px; `}
`;
*/

export default RecipesSection;


// WEBPACK FOOTER //
// ./src/components/RecipesSection.js